export { default } from "./PrivacyContent";
